// ADR-104 for Learn's client: which of a served card's sides is its example
// and which its definition. LearnPage (the blanked sentence, the definition
// hint, the form line, the reference panel's context), the session hook (the
// spoken text, the mistakes list) and the previous-card overlay all read these
// two, so they cannot pick different sides of the same card.

import type { LearningNextCard, SideInfo } from '../types'
import { valueSide } from './fieldValue'

type ServedCard = Pick<LearningNextCard, 'prompt' | 'other_sides'>

/** The card's example value among the non-prompt sides: the first non-blank
 * Example. The prompt is not consulted, as before — only a Definition prompt
 * is served in practice, and a blanked sentence is built from other_sides. */
export function learnExampleSide(card: ServedCard): SideInfo | undefined {
  return valueSide(card.other_sides, 'example')
}

/** The card's definition value. The prompt is listed first: when it is a
 * Definition it is already the value (the server prompts with the first
 * non-blank one), and a blank Definition left in other_sides must not stand
 * in for it. */
export function learnDefinitionSide(card: ServedCard): SideInfo | undefined {
  return valueSide([card.prompt, ...card.other_sides], 'definition')
}
